import { CoreSetupAuditTrailViewsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSetupAuditTrailViews } from '@api';

export const getCoreSetupAuditTrailViewsSlice = createGetAsyncSlice({
	name: CoreSetupAuditTrailViewsName,
	receive: true,
	request: false,
	requestHandler: getSetupAuditTrailViews,
	retainDataOnRequest: true
});
